import { HttpService } from "@/core";
import { LicCategoryPageResp } from "./license-category.interface";

export class LicenseCategoryService {

  static usePageApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/cf_mng/cfc/page",
        params,
      });
    return HttpService.usePagination<LicCategoryPageResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/cf_mng/cfc/${id}`,
      });
    return HttpService.useRequest<any>(api);
  }

  static useCreateApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/cf_mng/cfc/add",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data) =>
      HttpService.axios({
        method: "PUT",
        url: `/cf_mng/cfc/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDelApi() {
    const api = (data) =>
      HttpService.axios({
        method: "PUT",
        url: `/cf_mng/cfc/batch/delete`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
}
